import {
    GET_PRODUCTS,
    GET_DETAIL_PRODUCT,
    GET_STATE_LOADING,
    GET_PRODUCT_BY_MODE,
    GET_PRODUCTS_CLIENT,
    GET_LIST_COUNTRY
} from "@/views/products/store/types/types.js";

const getters = {
    [GET_PRODUCTS]: state => state.products,
    [GET_DETAIL_PRODUCT]: state => state.detailproduct,
    [GET_PRODUCTS_CLIENT]: state => state.productsClient,
    [GET_STATE_LOADING]: state => state.loading,
    [GET_PRODUCT_BY_MODE]: state => state.product_by_mode,
    [GET_LIST_COUNTRY]: state => state.countryCode
};

export default getters;